export default "__VITE_ASSET__Dy1Iuhs4__"